import { render } from "./confirm-service-item.vue?vue&type=template&id=755dcdfd"
import script from "./confirm-service-item.vue?vue&type=script&lang=js"
export * from "./confirm-service-item.vue?vue&type=script&lang=js"

import "./confirm-service-item.vue?vue&type=style&index=0&id=755dcdfd&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__